
/* User defined models */
import { Reference, Dictionary } from "../common/shared.model";
import { Country } from "./country.model";
import { State } from "./state.model";
import { SiteSlot } from "./siteSlot.model";
import { Exam } from "./exam.model";
import { TestingAccommodation } from "./testingAccommodation.model";
import { Session } from "./session.model";

export class Eligibility {
  eligibilityDetails: Dictionary;
}

export class EligibilityDetail {
  id: string;
  href: string;
  number: string;
  programCode?: string;
  clientCode?: any;
  status?: any;
  consecutiveDays?: boolean;
  sessions?: Session[];
  demographics?: any;
  exam: Exam;
  restriction?: Restriction;
  testingAccommodations?: TestingAccommodation[];
  b2b?: boolean = false;
  scheduleSetAttributeCode?: boolean = false;
  rescheduleSetAttributeCode?: boolean = false;
  cancelSetAttributeCode?: boolean = false;
  maxDays?: number;
}

export class Restriction {
  startDate?: any;
  endDate?: any;
  sites?: SiteSlot[];
  countries?: Country[];
  rrcs?: State[];

  constructor(
    startDate?: any,
    endDate?: any,
    sites?: SiteSlot[],
    countries?: Country[],
    rrcs?: State[]
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.sites = sites;
    this.countries = countries;
    this.rrcs = rrcs;
  }
}
